var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3363 8.00001H10.3717M10.3717 8.00001L11.5575 6.81416M10.3717 8.00001L11.5575 9.18586M3.50858 12.4043L7.06614 13.4715C7.24323 13.5247 7.43031 13.5357 7.61242 13.5037C7.79453 13.4717 7.96663 13.3975 8.11497 13.2871C8.26331 13.1767 8.38379 13.0332 8.46677 12.868C8.54976 12.7027 8.59296 12.5204 8.59292 12.3355V3.66454C8.59296 3.47963 8.54976 3.29728 8.46677 3.13205C8.38379 2.96681 8.26331 2.82328 8.11497 2.7129C7.96663 2.60252 7.79453 2.52836 7.61242 2.49634C7.43031 2.46432 7.24323 2.47533 7.06614 2.52849L3.50858 3.59576C3.26431 3.66908 3.05019 3.8192 2.89798 4.02385C2.74578 4.2285 2.66361 4.47676 2.66367 4.7318V11.2682C2.66361 11.5233 2.74578 11.7715 2.89798 11.9762C3.05019 12.1808 3.26431 12.3309 3.50858 12.4043Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmit);
export default __webpack_public_path__ + "static/media/admit.b2c524f61713965abe16c30c4e0de729.svg";
export { ForwardRef as ReactComponent };